import PropTypes from "prop-types";
import React from "react";

const Accolades = ({ accolades, showAccolades }) => {
  if (!accolades || !accolades.content || !showAccolades) return null;
  let accoladesTitle = accolades.title;
  if (!accoladesTitle) {
    accoladesTitle = "ACCOLADES";
  }
  return (
    <div className="accolades">
      <h4 className="header-standard">{accoladesTitle}</h4>
      <p
        dangerouslySetInnerHTML={{
          __html: accolades.content.replace(/\r?\n/g, "<br/>"),
        }}
      ></p>
    </div>
  );
};

Accolades.propTypes = {
  accolades: PropTypes.string,
  accoladesTitle: PropTypes.string,
  showAccolades: PropTypes.bool.isRequired,
};

export default Accolades;



// WEBPACK FOOTER //
// ./src/components/about/accolades.js